import * as React from 'react';
import WireFrameCell from '../../../../elements/wireframe-cell';
import { CardContext, forceMobile } from '../generics';
import CellBase from './cell-base';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { jsxs as _jsxs } from "theme-ui/jsx-runtime";

var ProductTableCellSecondary = function ProductTableCellSecondary(_ref) {
  var children = _ref.children,
      label = _ref.label,
      headerImage = _ref.headerImage,
      _ref$isWireFrame = _ref.isWireFrame,
      isWireFrame = _ref$isWireFrame === void 0 ? false : _ref$isWireFrame;

  var _React$useContext = React.useContext(CardContext),
      isCard = _React$useContext.isCard;

  var forcedMobile = forceMobile(isCard);
  var wireFrameStyles = {
    label: {
      width: '45%',
      height: '10px',
      marginBottom: 'xs'
    },
    description: {
      width: '65%',
      height: '17px'
    }
  };
  return _jsxs(CellBase, {
    sx: {
      height: forcedMobile(['auto', null, headerImage ? 'auto' : '100%']),
      padding: forcedMobile(['', null, headerImage ? 0 : 'sm']),
      display: 'grid',
      alignItems: forcedMobile(['center', null, 'start']),
      gridTemplateColumns: forcedMobile(['repeat(2, 1fr)', null, '100%']),
      msGridColumns: forcedMobile(['repeat(2, 1fr)', null, '100%']),
      gridTemplateRows: forcedMobile(['100%', null, headerImage ? 'auto' : '1fr']),
      msGridRows: forcedMobile(['100%', null, headerImage ? 'auto' : '1fr']),
      variant: "compounds.product-table.".concat(headerImage && 'variants.redesign.', "cellContent.variants.inSplit.main")
    } // @ts-ignore
    ,
    css: {
      display: '-ms-grid'
    },
    children: [_jsxs("div", {
      sx: {
        gridColumn: '1 / span 1',
        msGridColumn: '1',
        msGridColumnSpan: '1',
        gridRow: headerImage ? forcedMobile(['1 / span 1', null, '1 / span 1']) : forcedMobile(['1 / span 1', null, '2 / span 1']),
        msGridRow: forcedMobile(['1', null, headerImage ? '1' : '2']),
        msGridRowSpan: '1',
        fontSize: 'xs',
        marginTop: headerImage ? 0 : 'sm',
        variant: "compounds.product-table.".concat(headerImage && 'variants.redesign.', "cellContent.variants.inSplit.label")
      },
      children: [isWireFrame && _jsx(WireFrameCell, {
        styles: wireFrameStyles.label
      }), !isWireFrame && label]
    }), _jsxs("div", {
      sx: {
        gridRow: headerImage ? forcedMobile(['1 / span 1', null, '2 / span 1']) : '1 / span 1',
        msGridRow: headerImage ? '2' : '1',
        msGridRowSpan: '1',
        gridColumn: forcedMobile(['2 / span 1', null, '1 / span 1']),
        msGridColumn: forcedMobile(['2', null, '1']),
        msGridColumnSpan: '1',
        fontSize: 'xxl',
        paddingLeft: forcedMobile(['sm', null, '0px']),
        marginTop: headerImage ? '0px' : forcedMobile(['sm', null, '0px']),
        small: {
          fontSize: 'sm'
        },
        lineHeight: 1,
        variant: "compounds.product-table.".concat(headerImage && 'variants.redesign.', "cellContent.variants.inSplit.content")
      },
      children: [isWireFrame && _jsx(WireFrameCell, {
        styles: wireFrameStyles.description
      }), !isWireFrame && children]
    })]
  });
};

export default ProductTableCellSecondary;
//# sourceMappingURL=cell-secondary.js.map